import { AdvertentieList } from "./AdvertentieList";

// advertentie-migration (Epic 22/23 Jmix-exit): de Advertenties-overzicht.
//
// Een rij opent het hele dier op zijn advertentietabblad, niet de advertentie op zichzelf (maintainer
// 2026-08-20). Dat is dezelfde editor, maar dan met de kop van het dier eromheen: wie een advertentie
// bijwerkt wil er toch bij kunnen wat er verder over dat dier bekend is. De wrapper houdt daarom geen
// eigen detailstaat meer bij — hij geeft alleen door welk dier geopend moet worden.
//
// De werklijst "kenmerken invullen" stond hier bóven het overzicht (epic 12, story 12-9) en is er op
// 2026-10-28 weer af. Hij vertelde hoe groot het werk was, maar niet bij wélk dier je zat te kijken:
// je zag "31 vragen open over 1362 advertenties", klapte de lijst uit, en zat daarna in een tweede
// overzicht naast het overzicht dat er al stond. Als rode markering op de rij zelf valt het op waar
// het hoort, en hoef je nergens heen om het te zien (Maarten).
export function AdvertentiesOverview({ onOpenAnimal, onPortaalInstellingen }: {
  onOpenAnimal?: (dierId: string) => void;
  /** Naar de instellingen van de publieke sites; zonder dit blijft de knop weg. */
  onPortaalInstellingen?: () => void;
} = {}) {
  return (
    <AdvertentieList
      onOpenDier={(dierId) => onOpenAnimal?.(String(dierId))}
      onPortaalInstellingen={onPortaalInstellingen}
    />
  );
}
